"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-lines-per-function */
/** @jsx jsx */
const carabiners_1 = require("@clearsummit/carabiners");
const core_1 = require("@emotion/core");
const framer_motion_1 = require("framer-motion");
const react_1 = __importStar(require("react"));
const constants_1 = require("@/constants");
const styles_1 = require("../../helpers/styles");
const hooks_1 = require("../../hooks");
const styled_react_1 = require("./styled-react");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Menu = ({ style, children, color, backgroundColor, hoverColor, borderRadius, closeOnBlur, closeOnSelect, isOpen, onClose, onOpen, buttonRef, offset, className, }) => {
    const ref = react_1.useRef(null);
    let posLeft = 0;
    let posTop = 0;
    let posRight = 0;
    let buttonWidth = 0;
    if (buttonRef.current) {
        const { left, top, right, height, width } = buttonRef.current.getBoundingClientRect();
        posLeft = left;
        posTop = top + height + 10;
        posRight = right;
        buttonWidth = width;
    }
    if (offset) {
        const { top, right, left } = offset;
        if (top) {
            posTop += top;
        }
        if (right) {
            posRight += right;
        }
        if (left) {
            posLeft += left;
        }
    }
    const handleClickOutside = () => {
        if (closeOnBlur && isOpen) {
            onClose();
        }
    };
    hooks_1.useOnClickOutside(ref, handleClickOutside);
    react_1.useEffect(() => {
        if (isOpen) {
            if (onOpen) {
                onOpen();
            }
        }
    }, [isOpen]);
    return (core_1.jsx(framer_motion_1.motion.div, { ref: ref, initial: false, animate: isOpen ? 'enter' : 'exit', variants: styled_react_1.motionVariants, css: styles_1.customCssWrapper(styled_react_1.menuDynamicStyle(color, backgroundColor, borderRadius, posLeft, posTop, posRight, buttonWidth, offset), style), className: carabiners_1.joinStr(styles_scss_1.default.menu, className) }, react_1.default.Children.map(children, (c, i) => react_1.default.cloneElement(c, {
        hoverColor,
        isFirstChild: i === 0,
        isLastChild: i === children.length - 1,
        borderRadius,
        tabIndex: c.props.tabIndex || i,
        closeOnSelect,
        onClose,
    }))));
};
Menu.defaultProps = {
    style: undefined,
    color: styles_scss_1.default.charcoal,
    backgroundColor: styles_scss_1.default.white,
    hoverColor: styles_scss_1.default.lightGrey,
    borderRadius: styles_scss_1.default.xxxs,
    closeOnBlur: true,
    closeOnSelect: false,
    isOpen: false,
    onClose: undefined,
    onOpen: undefined,
    offset: undefined,
    className: undefined,
};
const MenuItem = react_1.forwardRef(({ children, hoverColor, closeOnSelect, icon, isCascadingMenu, isFirstChild, isLastChild, borderRadius, tabIndex, onClick, onClose, className, }, ref) => {
    const onClickItem = () => {
        if (onClick) {
            onClick();
        }
        if (closeOnSelect) {
            onClose();
        }
    };
    return (core_1.jsx("div", { ref: ref, onClick: onClickItem, role: "button", tabIndex: tabIndex, onKeyPress: e => {
            if (e.key === 'Enter') {
                onClickItem();
            }
        }, className: className, css: styled_react_1.menuItemDynamicStyle(hoverColor, isFirstChild, isLastChild, borderRadius) },
        icon && core_1.jsx("span", { className: styles_scss_1.default.icon }, icon),
        children,
        isCascadingMenu && (core_1.jsx("span", { className: styles_scss_1.default.chevron },
            core_1.jsx("img", { src: constants_1.Images.chevronRight, alt: "chevron-icon" })))));
});
MenuItem.defaultProps = {
    tabIndex: undefined,
    icon: undefined,
    isCascadingMenu: false,
    onClick: undefined,
    className: undefined,
};
const MenuDivider = ({ color, stroke, }) => core_1.jsx("div", { css: styled_react_1.menuDividerDynamicStyle(stroke, color) });
MenuDivider.defaultProps = {
    color: styles_scss_1.default.lightGrey,
    stroke: styles_scss_1.default.xxxxs,
};
Menu.MenuItem = MenuItem;
Menu.MenuDivider = MenuDivider;
exports.default = Menu;
